<template>
	<div class="data-table" :class="{ 'dark-theme': isDark }">
		<div v-if="isTitle">
			<div class="view_title flex_between">
				{{ pageMeta.title }}
				<slot name="titleBtn"></slot>
			</div>
			<el-divider />
		</div>
		<el-form :validate-on-rule-change="false" :label-suffix="labelSuffix" ref="ruleForm" :model="ruleForm"
			size="mini" :rules="formRules" :disabled="disabled" :label-width="labelWidth" class="demo-ruleForm">
			<el-row>
				<el-col :span="item.span||24" v-for="(item,index) in formDataList" :key="index" v-if="item.isShow!='no'">
					<div>
						<div v-if="item.type==='divider'" :id="item.id" style="padding: 20px 0;">
							<el-divider content-position="left">
								<span style="font-size: 20px;color:#409EFF ;">{{item.title}}</span>
							</el-divider>
						</div>
						<div v-else-if="!item.showType||(ruleForm[item.showType]===item.showTypeValue)">
							<el-form-item :ref="item.prop" :label="item.label"
								:prop="ruleForm.id?item.updateProp||item.prop:item.prop">
								<div v-if="item.slot">
									<slot :name="item.slot"
										:updateData="(val) => updateField(item.prop || item.value, val)"
										:data="ruleForm[item.prop || item.value]" />
								</div>

								<!-- 普通输入框 -->
								<el-input v-if="item.formType==='input'||item.formType==='textarea'"
									type="text" v-model="ruleForm[item.prop]" class="form_input"
									:maxlength="item.max" :show-word-limit="item.max>0"
									:type="item.formType"
									:placeholder="item.placeholder||`请输入${item.label}`" />

								<!-- 富文本 -->
								<RichEditor v-if="item.formType==='richText'"
									v-model="ruleForm[item.prop]"
									:height="item.height||300"
									:placeholder="item.placeholder||`请输入${item.label}`"
									:disabled="disabled || item.disabled" />

								<!-- 数字框 -->
								<el-input-number v-if="item.formType==='number'" v-model="ruleForm[item.prop]"
									class="form_input" :controls="false" :min="(typeof item.min=='number')?item.min:0"
									:max="item.max||9999999" :placeholder="item.placeholder||`请输入${item.label}`" />

								<!-- 下拉框 -->
								<div v-if="item.formType==='select'">
									<el-select v-if="ruleForm.id&&item.updateProp" v-model="ruleForm[item.updateProp]"
										class="form_input" clearable filterable :multiple="item.multiple"
										:placeholder="item.placeholder||`请选择${item.label}`"
										@change="changeForm($event,item)">
										<el-option v-for="(row,index) in item.selectList" :key="index"
											:label="row.label" :value="row.value" />
									</el-select>
									<el-select v-else v-model="ruleForm[item.prop]" class="form_input" clearable
										filterable :multiple="item.multiple"
										:placeholder="item.placeholder||`请选择${item.label}`"
										@change="changeForm($event,item)">
										<el-option v-for="(row,index) in item.selectList" :key="index"
											:label="row.label" :value="row.value" />
									</el-select>
								</div>

								<!-- ✅ 方案 A：原生级联选择器 (Cascader) -->
								<div v-if="item.formType==='cascader'" style="width: 100%;">
									<el-cascader
										:key="item.prop + '-' + ruleForm[item.prop]"
										v-model="ruleForm[item.prop]"
										class="form_input"
										:options="item.options || []"
										:props="item.cascaderProps || { checkStrictly: true, emitPath: false }"
										:placeholder="item.placeholder || `请选择${item.label}`"
										clearable
										filterable
										@change="(val) => handleCascaderChange(val, item)"
									/>
								</div>

								<!-- ✅ 方案 B：手写树形下拉 (Tree-Select) -->
								<div v-if="item.formType==='tree-select'" style="width: 100%; max-width: 400px;">
									<el-popover
										v-model="item.treeVisible"
										placement="bottom-start"
										width="300"
										trigger="click"
										@show="() => { item.treeVisible = true }"
									>
										<el-input
											slot="reference"
											:value="getTreeSelectedLabel(ruleForm[item.prop], item.options)"
											readonly
											:placeholder="item.placeholder || `请选择${item.label}`"
											class="form_input"
											style="cursor: pointer;"
											suffix-icon="el-icon-arrow-down"
										/>
										<div style="max-height: 300px; overflow-y: auto;">
											<el-tree
												:data="item.options || []"
												:props="item.treeProps || { label: 'label', children: 'children' }"
												node-key="value"
												:current-node-key="ruleForm[item.prop]"
												:highlight-current="true"
												:expand-on-click-node="false"
												@node-click="(data, node) => handleTreeClick(data, node, item)"
											/>
										</div>
									</el-popover>
								</div>

								<!-- 颜色选择器 -->
								<el-color-picker v-if="item.formType==='color'"
									v-model="ruleForm[item.prop]"></el-color-picker>

								<!-- 单选框 -->
								<div v-if="item.formType==='radio'">
									<el-radio-group v-if="ruleForm.id&&item.updateProp"
										v-model="ruleForm[item.updateProp]" filterable >
										<el-radio :label="select.value" v-for="(select,selectIndex) in item.selectList"
											:key="selectIndex">{{select.label}}</el-radio>
									</el-radio-group>
									<el-radio-group v-else v-model="ruleForm[item.prop]" filterable >
										<el-radio :label="select.value" v-for="(select,selectIndex) in item.selectList"
											:key="selectIndex">{{select.label}}</el-radio>
									</el-radio-group>
									<el-input v-if="item.isInput" v-model="ruleForm[item.prop]" class="form_input" placeholder="请输入自定义"></el-input>
								</div>
								
								<!-- 经纬度选点 -->
								<div v-if="item.formType==='location'">
									<el-button type="primary" plain icon="el-icon-location-information" @click="goSelectMAp(item)">选择经纬度</el-button>
									<span v-if="ruleForm[item.prop]&&ruleForm[item.prop1]">
										{{ruleForm[item.prop]||''}},{{ruleForm[item.prop1]||''}}
									</span>
								</div>

								<!-- 远程搜索下拉 -->
								<el-select v-if="item.formType==='selectSearch'" v-model="ruleForm[item.prop]"
									filterable class="form_input" remote reserve-keyword
									:remote-method="(e)=>getSelectSearch(e,item)"
									:placeholder="item.placeholder||`请选择${item.label}`">
									<el-option v-for="(select,selectIndex) in item.selectList" :key="selectIndex"
										:label="select.label" :value="select.value">
									</el-option>
								</el-select>
								
								<!-- 开关 -->
								<el-switch v-if="item.formType==='switch'" v-model="ruleForm[item.prop]"
									active-color="#13ce66" inactive-color="#ff4949" />
								
								<!-- 日期 -->
								<el-date-picker  class="form_input" v-if="item.formType==='date'" v-model="ruleForm[item.prop]"
									:type="item.dateType||'date'" :value-format="item.format||'yyyy-MM-dd'"
									:placeholder="`选择${item.label}`" />
								
								<!-- 图片上传 -->
								<UploadImage v-if="item.formType==='img'" v-model="ruleForm[item.prop]" :limit="(item.formProps && item.formProps.limit) || 1" />
								
								<span class="form_remark" v-if="item.end">{{item.end}}</span>
								<p v-if="item.remark" class="form_remark">
									{{ item.remark }}
								</p>
							</el-form-item>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-form-item v-if="!disabled">
				<el-button v-if="isSubmitForm" style="width: 180px;" class="form_btn" size="small" type="primary"
					@click="submitForm('ruleForm')">{{btnText}}</el-button>
			</el-form-item>
		</el-form>
		<MapSelect ref="mapSite" @confrimAdress="confrimAdress"></MapSelect>
	</div>
</template>

<script>
	import api from "@/utils/api";
	import MapSelect from "./MapSelect.vue"

	function pickArray(res) {
		if (!res) return []
		const candidates = [
			res.data, res.data && res.data.data, res.data && res.data.items,
			res.data && res.data.list, res.data && res.data.rows, res,
		]
		for (const c of candidates) {
			if (Array.isArray(c) && c.length > 0) return c
		}
		for (const c of candidates) {
			if (Array.isArray(c)) return c
		}
		return []
	}

	export default {
		components: {
			MapSelect
		},
		props: {
			isPageForm: { type: Boolean, default: () => false },
			upDateApi: { type: String, default: '' },
			formApi: { type: String, default: '' },
			labelSuffix: { type: String, default: '' },
			btnText: { type: String, default: '保存' },
			isHttps: { type: Boolean, default: false },
			disabled: { type: Boolean, default: false },
			isSubmitForm: { type: Boolean, default: true },
			isTitle: { type: Boolean, default: true },
			isSetRules: { type: Boolean, default: false },
			formData: { type: Array, default: () => [] },
			rules: { type: Object, default: () => {} },
			labelWidth: { type: String, default: '150px' },
			isUpdate: { type: Boolean, default: false },
		},
		data() {
			return {
				mapItem: null,
				isDark: false,
				imgSrc: this.$store.state.user.imgSrc,
				action: process.env.VUE_APP_BASE_API + '/api/fileManage/uploadFile',
				pageMeta: {},
				imgType: null,
				inputValue: null,
				inputVisible: false,
				ruleForm: {},
				formDataList: []
			}
		},
		computed: {
			headers() {
				return { 'ContentType': 'multipart/form-data' }
			},
			formRules() {
				const selectProp = ["input", 'inputNumber', 'cascader', 'tinymce', 'richText', 'tree-select']
				let rules = {}
				this.formDataList.forEach((item) => {
					if (item.isRulesFunction) {
						if (item.isRulesFunction(this.ruleForm)) {
							rules[item.prop] = [{ required: true, message: item.placeholder || (selectProp.includes(item.formType || item.type) ? '请输入' : '请选择') + item.label }]
						}
					} else if (item.isRules !== false) {
						if (item.updateProp && this.ruleForm.id) {
							rules[item.updateProp] = [{ required: true, message: item.label }]
						} else if (item.prop1 && item.prop2) {
							rules[item.prop1] = [{ required: true, message: item.placeholder }]
							rules[item.prop2] = [{ required: true, message: item.placeholder }]
						} else if (item.isArr) {
							rules[item.prop] = [{ required: true, message: '请添加' + item.label }]
						} else {
							rules[item.prop] = [{ required: true, message: item.placeholder || (selectProp.includes(item.formType || item.type) ? '请输入' : '请选择') + item.label }]
						}
					}
				})
				return { ...rules, ...this.rules }
			}
		},
		mounted() {
			this.$root.$on('theme-change', (dark) => { this.isDark = dark; });
			this.isDark = localStorage.getItem('theme') === 'dark';
			this.pageMeta = this.$route.meta;

			this.formData.forEach(async (item, key) => {
				if (item.isArr) {
					const k = item.prop || item.value;
					this.$set(this.ruleForm, k, []);
				}
				if (item.api) {
					await api.get(item.api, { pageNum: 1, pageSize: 10000 }).then((res) => {
						let dataList = item.dataProp ? (item.dataProp.split('.').reduce((o, k) => o?.[k], res) || []) : pickArray(res)
						if (!Array.isArray(dataList)) dataList = []
						const labelArr = item.props?.label ? item.props.label.split(',') : []
						const selectList = dataList.map((listItem) => {
							const labelData = []
							labelArr.forEach((labelItem) => { labelData.push(listItem[labelItem]) })
							return {
								label: labelData.length ? labelData.join('-') : listItem,
								value: item.props?.value ? listItem[item.props.value] : listItem,
							}
						})
						this.$set(item, 'selectList', selectList)
					})
				}
				if (key === (this.formData.length - 1) && !this.isUpdate) {
					this.setFOrmList()
				}
			})
		},
		watch: {
			formData: {
				handler(newVal) {
					this.formDataList = newVal.filter((item) => {
						return !this.ruleForm.id || (this.ruleForm.id && item.isUpdate !== false)
					})
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			/* ==================== 级联选择器 (Cascader) 相关 ==================== */
			handleCascaderChange(val, item) {
				this.$set(this.ruleForm, item.prop, val)
			},

			/* ==================== 树形下拉 (Tree-Select) 相关 ==================== */
			handleTreeClick(data, node, item) {
				// 如果点的是省份（有 children），只展开，不给表单赋值
				if (data.children && data.children.length > 0) {
					node.expanded = !node.expanded
					return
				}
				// 只有点到了最底层（市/区），才赋值
				this.$set(this.ruleForm, item.prop, data.value)
				item.treeVisible = false
			},
			
			getTreeSelectedLabel(value, options) {
				if (!value || !options) return ''
				const findLabel = (nodes, path = []) => {
					for (let node of nodes) {
						const currentPath = [...path, node.label]
						if (node.value === value && (!node.children || node.children.length === 0)) {
							// 如果想显示 "北京 / 东城区" 可以用 currentPath.join(' / ')
							// 这里为了和级联保持一致的默认展示，只返回最后一级的 label
							return node.label
						}
						if (node.children) {
							const res = findLabel(node.children, currentPath)
							if (res) return res
						}
					}
					return null
				}
				return findLabel(options) || ''
			},

			/* ==================== 其他基础方法 ==================== */
			goSelectMAp(item) {
				this.$refs.mapSite.show({
					address: this.ruleForm[item.mapName] || '',
					lng: this.ruleForm[item.prop] || '',
					lat: this.ruleForm[item.prop1] || ''
				})
				this.mapItem = item
			},
			confrimAdress(e, item) {
				if (this.mapItem) {
					this.$set(this.ruleForm, this.mapItem.prop, e.latlng.lng)
					this.$set(this.ruleForm, this.mapItem.prop1, e.latlng.lat)
				}
			},
			setFOrmList() {
				this.formDataList = this.formData.filter((item) => {
					return !this.ruleForm.id || (this.ruleForm.id && item.isUpdate !== false)
				})
			},
			updateField(prop, data) {
				this.$set(this.ruleForm, prop, data)
			},
			changeImg(e, prop) {
				this.ruleForm[prop] = (e || []).join(',')
			},
			setFormData(data) {
				this.ruleForm = Object.assign({}, data)
				if (this.isUpdate) {
					this.setFOrmList()
				}
			},
			getSelectSearch(e, item) {
				const data = {}
				if (item.searchProp) { data[item.searchProp] = e }
				this.$apiRequest(item.api, { pageNum: 1, pageSize: 100, ...data }).then((res) => {
					let selectList = res.data.records.map((listItem) => {
						return { label: listItem[item.props.label], value: listItem[item.props.value] }
					})
					this.$set(item, 'selectList', selectList)
				})
			},
			handleClose(tag, prop) { this.ruleForm[prop].splice(this.ruleForm[prop].indexOf(tag), 1); },
			showInput() { this.inputVisible = true; this.$nextTick(() => { this.$refs.saveTagInput[0].$refs.input.focus(); }); },
			handleInputConfirm(e, prop) {
				let inputValue = this.inputValue;
				if (inputValue) { this.ruleForm[prop].push(inputValue); }
				this.inputVisible = false; this.inputValue = '';
			},
			setDifCover(e, prop) { this.ruleForm[prop] = e },
			removeCover(data, prop) { this.ruleForm[prop].splice(data.name, 1) },
			setBanner(data, prop) { let cover = this.isHttps ? this.imgSrc + data.cover : data.cover; this.$set(this.ruleForm[prop], data.index, cover) },
			setCoverList(e, type) { let cover = this.isHttps ? this.imgSrc + e : e; this.ruleForm[type].push(cover) },
			changeForm(e, item) { this.$emit('changeForm', e, item.value, item) },
			goValidateField(value) { this.$refs.ruleForm.validateField(value) },
			setpickerTime(e) {
				const _self = this
				return { disabledDate(time) { return time.getTime() < new Date(_self.ruleForm[e]).getTime() } }
			},
			beforeAudioUpload(file) {
				const formData = new FormData(); formData.append('file', file.raw, file.name);
				goUploadImg(formData).then((res) => { this.$set(this.ruleForm, this.imgType, res.data) })
			},
			handleAudioSuccess(res) {},
			handleAvatarSuccess(response) {
				if (response.ret === 1000) {
					if (this.isHttps) { this.ruleForm[this.imgType] = this.imgSrc + response.data } 
					else { this.ruleForm[this.imgType] = response.data }
				} else if (response.ret === 6000) {
					this.$confirm(response.msg, '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => { this.$store.dispatch('user/resetToken').then(() => { location.reload() }) })
				} else { this.$message.error(response.msg) }
			},
			beforeAvatarUpload(file) {
				this.openLoading('努力上传中')
				const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png' || file.raw.type === 'image/gif' || file.raw.type === 'image/webp'
				const isLt2M = file.size / 1024 / 1024 < 2
				if (!isJPG) { this.openLoading().close(); this.$message.error('上传图片只能是 JPG/png 格式!'); return false; }
				if (!isLt2M && this.isLimit) { this.openLoading().close(); this.$message.error('上传图片大小不能超过 2MB!'); return false; }
				const _self = this
				const width = _self.feilWidth
				const height = _self.feilHeight
				new Promise(function(resolve, reject) {
					const URL = window.URL || window.webkitURL
					const img = new Image()
					img.onload = function() {
						if (width > 0 && height > 0) { valid = img.width === width && img.height === height; valid ? resolve() : reject() } 
						else { img.width > 750 ? reject() : resolve() }
					}
					img.src = URL.createObjectURL(file.raw)
				}).then(() => {
					let quality = 1
					if (file.size / 1024 > 500) { quality = 0.4 } else if (file.size / 1024 > 300) { quality = 0.5 } else if (file.size / 1024 > 200) { quality = 0.6 }
					new Compressor(file.raw, { quality: quality, success(result) {
						const formData = new FormData(); formData.append('file', result, result.name);
						goUploadImg(formData).then((res) => {
							if (_self.isHttps) { _self.$set(_self.ruleForm, _self.imgType, (_self.imgSrc + res.data)) } 
							else { _self.$set(_self.ruleForm, _self.imgType, res.data) }
						})
					}, error(err) {} })
				}, () => {
					if (width > 0 && height > 0) { this.$message.error(`请上传${_self.feilWidth}*${_self.feilHeight}的图片`) } 
					else { this.$message.error(`上传的图片宽度不能大于750`) }
					this.openLoading().close()
					return Promise.reject()
				})
				return
			},
			scrollView(e) {
				let dom = this.$refs[e][0]
				return
				dom.$el.scrollIntoView({ block: 'center', behavior: 'smooth' });
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid, object) => {
					if (valid) {
						if (this.isPageForm) { this.$emit('submitForm', this.ruleForm); return }
						if (this.upDateApi && this.ruleForm.id) {
							const upDateApi = this.upDateApi.endsWith('/') ? `${this.upDateApi}${this.ruleForm.id}` : this.upDateApi
							api.put(upDateApi, this.ruleForm).then((res) => { this.$emit('submitFormSuccess') })
							return
						}
						api.post(this.formApi, this.ruleForm).then((res) => { this.$emit('submitFormSuccess') })
					} else {
						var data = Object.keys(object)
						if (this.$refs[data[0]]) {
							let dom = this.$refs[data[0]][0]
							dom.$el.scrollIntoView({ block: 'center', behavior: 'smooth' });
						} else { this.$emit('goScrollIntoView', data[0]) }
						return false
					}
				})
			}
		},
		beforeDestroy() {
			this.$root.$off('theme-change');
		}
	}
</script>

<style>
	.el-input-number.is-without-controls .el-input__inner{ text-align: left; }
</style>
<style scoped>
	.data-table { background-color: var(--bg-color); transition: all 0.3s ease; }
	.form_remark { font-size: 12px; margin-left: 10px; color: #999; }
	.form_inputNumber .el-input__inner { text-align: left !important; }
	.form_inputNumber { max-width: 200px; width: 100%; }
	.form_input { width: 100% !important; max-width: 400px; }
	.form_input .el-input__inner { text-align: left !important; }
	
	.avatar-uploader .el-upload { border: 1px dashed #d9d9d9; border-radius: 6px; cursor: pointer; position: relative; overflow: hidden; }
	.avatar-uploader .el-upload:hover { border-color: #409EFF; }
	.avatar-uploader-icon { font-size: 28px; color: #8c939d; width: 100px; height: 100px; line-height: 100px; text-align: center; }
	.avatar { width: 100px; height: 100px; display: block; }

	.dark-theme ::v-deep .view_title { color: #e4e7ed; }
	.dark-theme ::v-deep .el-form-item__label { color: #e4e7ed; }
	.dark-theme ::v-deep .el-input__inner { background-color: #333333; border-color: #404040; color: #e4e7ed; }
	.dark-theme ::v-deep .el-input__inner::placeholder { color: #909399; }
	.dark-theme ::v-deep .el-select .el-input__inner { background-color: #333333; }
	.dark-theme ::v-deep .el-input-number .el-input__inner { background-color: #333333; }
	.dark-theme ::v-deep .el-textarea__inner { background-color: #333333; border-color: #404040; color: #e4e7ed; }
	.dark-theme ::v-deep .el-textarea__inner::placeholder { color: #909399; }
	.dark-theme ::v-deep .el-radio { color: #e4e7ed; }
	.dark-theme ::v-deep .el-radio__label { color: #e4e7ed; }
	.dark-theme ::v-deep .el-divider__text { background-color: var(--bg-color); color: #409EFF; }
	.dark-theme ::v-deep .el-divider { background-color: #404040; }
	.dark-theme ::v-deep .el-dialog { background-color: #2a2a2a; }
	.dark-theme ::v-deep .el-dialog__title { color: #e4e7ed; }
	.dark-theme ::v-deep .el-dialog__headerbtn .el-dialog__close { color: #e4e7ed; }
	.dark-theme ::v-deep .el-dropdown-menu { background-color: #333333; border-color: #404040; }
	.dark-theme ::v-deep .el-dropdown-menu__item { color: #e4e7ed; }
	.dark-theme ::v-deep .el-dropdown-menu__item:hover { background-color: #404040; }
	.dark-theme ::v-deep .el-select-dropdown { background-color: #333333; border-color: #404040; }
	.dark-theme ::v-deep .el-select-dropdown__item { color: #e4e7ed; }
	.dark-theme ::v-deep .el-select-dropdown__item:hover { background-color: #404040; }
	.dark-theme ::v-deep .el-select-dropdown__item.selected { color: #409EFF; }
	.dark-theme ::v-deep .el-popper[x-placement^=bottom] .popper__arrow::after { border-bottom-color: #333333; }
	.dark-theme ::v-deep .el-popper[x-placement^=top] .popper__arrow::after { border-top-color: #333333; }
	.dark-theme ::v-deep .el-popper[x-placement^=left] .popper__arrow::after { border-left-color: #333333; }
	.dark-theme ::v-deep .el-popper[x-placement^=right] .popper__arrow::after { border-right-color: #333333; }
	.dark-theme ::v-deep .el-date-picker { background-color: #333333; }
	.dark-theme ::v-deep .el-picker-panel { background-color: #333333; color: #e4e7ed; border-color: #404040; }
	.dark-theme ::v-deep .el-date-picker__header-label { color: #e4e7ed; }
	.dark-theme ::v-deep .el-date-table th { color: #e4e7ed; }
	.dark-theme ::v-deep .el-date-table td .el-date-table-cell { color: #e4e7ed; }
	.dark-theme ::v-deep .el-date-table td.today .el-date-table-cell { color: #409EFF; }
	.dark-theme ::v-deep .el-date-table td.available:hover { background-color: #404040; }
	.dark-theme ::v-deep .el-time-panel { background-color: #333333; border-color: #404040; }
	.dark-theme ::v-deep .el-time-spinner__item { color: #e4e7ed; }
	.dark-theme ::v-deep .el-time-spinner__item:hover:not(.disabled):not(.active) { background-color: #404040; }
	.dark-theme ::v-deep .el-time-spinner__item.active:not(.disabled) { color: #409EFF; }
	.dark-theme ::v-deep .form_remark { color: #909399; }
</style>